import { AuthenticatedRoute } from '@/auth/components/authenticated-route';
import { UnauthenticatedRoute } from '@/auth/components/unauthenticated-route';
import { NotFoundPage } from '@/components/NotFoundPage';
import { GA_TRACKING_ID } from '@/config';
import { DashboardRouter } from '@/dashboard/components/dashboard-router';
import { LoginPage } from '@/login/components/login-page';
import { LogoutPage } from '@/login/components/logout-page';
import * as userSelectors from '@/user/user-selectors';
import { getPlaceSpecificUrl } from '@/utils/place-detection';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { routes } from './routes';

// Initializes google analytics access ID this only needs to be done once in the app
ReactGA.initialize(GA_TRACKING_ID);

export default function Router({
  isAuthenticated,
}: {
  isAuthenticated: boolean;
}) {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  });

  const currentPlace = useSelector(userSelectors.currentCity);

  return (
    <React.Fragment>
      <Switch>
        <UnauthenticatedRoute
          isAuthenticated={isAuthenticated}
          path={[routes.LOGIN]}
          component={LoginPage}
        />
        <Route path={[routes.LOGOUT]} component={LogoutPage} />
        {/*
            If not authenticated, redirect "/" to "/login",
            otherwise redirect "/" to "/:region/home"
          */}
        <AuthenticatedRoute
          path={routes.ROOT}
          exact
          isAuthenticated={isAuthenticated}
          render={() =>
            currentPlace && (
              <Redirect
                exact
                path={routes.ROOT}
                to={getPlaceSpecificUrl(currentPlace, routes.MAP)}
              />
            )
          }
        />
        {/* Redirect /:region to /:region/home */}
        <Redirect
          exact
          path={'/:region'}
          to={
            !currentPlace
              ? routes.LOGIN
              : getPlaceSpecificUrl(currentPlace, routes.MAP)
          }
        />
        {/* Main router to render the dashboard related routes */}
        <AuthenticatedRoute
          isAuthenticated={isAuthenticated}
          path={routes.DASHBOARD_ROUTE}
          component={DashboardRouter}
        />
        {/* Fallback route to render the NotFoundPage */}
        <Route component={NotFoundPage} />
      </Switch>
    </React.Fragment>
  );
}
